export const containsHTML = (str) => /<[a-z][\s\S]*>/i.test(str);
